import { render, staticRenderFns } from "./selfExTipDialog.vue?vue&type=template&id=33655111&scoped=true"
import script from "./selfExTipDialog.vue?vue&type=script&lang=js"
export * from "./selfExTipDialog.vue?vue&type=script&lang=js"
import style0 from "./selfExTipDialog.vue?vue&type=style&index=0&id=33655111&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33655111",
  null
  
)

export default component.exports